import { defaultLocale, locales } from "@/i18n/routing";
import { Debug } from "@/util/debug";
import { AuthCRUD, LayoutProps, MenuProps, UserProps } from "@/components/layout/layoutType";
type treeKey = { category: string; group: string; tab: string };
type CRUDCheck = { crud: boolean | null; create: boolean | null; read: boolean | null; update: boolean | null; delete: boolean | null };
type auth = { auth: string; check: string; default: boolean };
const tree = require("@datas/tree.json");
if (process.env.NEXT_PUBLIC_SETTING_MODE !== "admin") {
  const setting_sub = tree["setting"].sub;
  Object.keys(setting_sub).forEach((key) => {
    if (key !== "userinfo") {
      delete setting_sub[key];
    }
  });
}
const command_arr = ["crud", "create", "read", "update", "delete", "list"];
const auth_arr: auth[] = [
  { auth: "write", check: "create", default: false },
  { auth: "view", check: "read", default: true },
  { auth: "edit", check: "update", default: false },
  { auth: "remove", check: "delete", default: false },
  { auth: "listview", check: "list", default: true },
];
const setLink = (obj: any, category?: string | undefined, group?: string | undefined, tab?: string | undefined) => {
  if (obj != null) {
    Object.keys(obj).forEach((key) => {
      try {
        //var temp = obj[key];
        obj[key].name = key;
        if (obj[key].path == null) {
          obj[key].path = key;
        }
        obj[key].link = "/" + (category ?? "") + "/" + (group ?? "") + "/" + (tab ?? "");
        obj[key].link = obj[key].link.replaceAll(/[/]{2,}/g, "/");
        obj[key].link += obj[key].path;
      } catch (e) {
        Debug(obj);
        Debug("error : ", category, group, tab, key);
      }
    });
  }
};
const crudInit = (obj: any, crud: any) => {
  if (obj == null) return;
  command_arr.forEach((command) => {
    if (obj[command] != null) crud[command] = obj[command];
  });
};
const crudUpdate = (obj: any) => {
  if (obj == null) return;
  if (obj.crud != null) {
    command_arr.forEach((command) => {
      if (command !== "crud") {
        if (obj[command] == null) obj[command] = obj.crud;
      }
    });
  }
};
const crudInsert = (obj: any, crud: any) => {
  if (obj == null) return;
  command_arr.forEach((command) => {
    if (obj[command] == null && crud[command] != null) {
      if (command !== "crud") {
        obj[command] = crud[command];
      }
    }
  });
};

const checkRead = (obj: any, user: UserProps | undefined) => {
  checkAuthObj(obj, user, { auth: "listview", check: "list", default: true });
  checkAuthObj(obj, user, { auth: "view", check: "read", default: true });
};

const checkAuth = (obj: any, user: UserProps | undefined) => {
  if (obj == null) return;
  auth_arr.forEach((auth) => {
    checkAuthObj(obj, user, auth, true);
  });
};
const checkAuthObj = (obj: any, user: UserProps | undefined, auth: auth, authForce?: boolean) => {
  if (obj == null) return;
  if (obj[auth.check] != null) {
    obj[auth.auth] = false;
    if (typeof obj[auth.check] === "string") {
      if (user != null && user.usertype != null) {
        obj[auth.auth] = user.usertype.includes(obj[auth.check]);
      } else {
        if (obj[auth.check] === "GUEST" && (user === null || user === undefined)) {
          obj[auth.auth] = true;
        }
      }
    } else {
      if (user != null && user.usertype != null) {
        //Debug("user type : " + user.usertype + "," + result[item][checkType]);
        user.usertype.forEach((usertype) => {
          //Debug("user type : " + usertype);
          if (obj[auth.check].includes(usertype)) {
            obj[auth.auth] = true;
          }
        });
      } else {
        if ((user === null || user === undefined) && obj[auth.check].includes("GUEST")) {
          obj[auth.auth] = true;
        }
      }
    }
  } else {
    if (authForce) {
      obj[auth.auth] = auth.default;
    }
  }
};

const checkCRUD = (obj: any, crud: CRUDCheck, user: UserProps | undefined, auth?: Record<string, AuthCRUD>) => {
  if (obj == null) return;
  const check_auth: Record<string, AuthCRUD> | undefined = auth ? { ...auth } : undefined;

  Object.keys(obj).forEach((item) => {
    //Debug("check crud : " + item + " - " + user?.userid);
    if (auth !== null && check_auth && obj[item].auth === undefined) {
      obj[item].auth = { ...check_auth };
    }
    const obj_auth = obj[item].auth;
    if (obj_auth) {
      Object.keys(obj_auth).forEach((key) => {
        if (obj_auth[key]) {
          const temp_edit = obj_auth[key].edit;
          if (temp_edit) {
            if (!obj_auth[key].create) {
              obj_auth[key].create = [...temp_edit];
            }
            if (!obj_auth[key].update) {
              obj_auth[key].update = [...temp_edit];
            }
          }
          const temp_crud = obj_auth[key].crud;
          if (temp_crud) {
            if (!obj_auth.create) {
              obj_auth[key].create = [...temp_crud];
            }
            if (!obj_auth[key].read) {
              obj_auth[key].read = [...temp_crud];
            }
            if (!obj_auth[key].update) {
              obj_auth[key].update = [...temp_crud];
            }
            if (!obj_auth[key].delete) {
              obj_auth[key].delete = [...temp_crud];
            }
            if (!obj_auth[key].list) {
              // if (obj_auth[key].read) {
              //   obj_auth[key].list = obj_auth[key].read;
              // } else {
              // }
              obj_auth[key].list = [...temp_crud];
            }
            // if (!obj_auth[key].menu) {
            //   obj_auth[key].menu = [...temp_crud];
            // }
            // if (auth) {
            //   Debug(auth, check_auth);
            // }
            // } else {
            //   Debug(auth, check_auth[key].crud);
          }
        }
      });
    }
    //Debug(item, crud, obj[item].auth);
    checkCRUDObj(obj[item], crud, user);
  });
};

const checkCRUDObj = (obj: any, crud: CRUDCheck, user: UserProps | undefined) => {
  crudUpdate(obj);
  crudInsert(obj, crud);
  crudUpdate(obj);
  checkRead(obj, user);
};

function setObjName(obj: any) {
  Object.keys(obj).forEach((key) => {
    obj[key].name = key;
  });
}
function firstMenu(obj: any): string {
  const list: any[] = Object.values(obj);
  listSort(list);
  return list.length > 0 ? (list[0]?.path ?? "") : "";
}
function findKey(obj: any, path: string): string {
  let result = "";
  Object.keys(obj).forEach((key) => {
    if (obj[key].path === path) {
      result = key;
    }
  });
  return result;
}

function listSort(list: any[]) {
  const l: number = list.length;
  if (l > 0) {
    list.sort(function (a, b) {
      a.display ?? true;
      const default_a = (a.display ?? true) ? (a.default ?? l) : l;
      const default_b = (b.display ?? true) ? (b.default ?? l) : l;
      return default_a - default_b;
    });
  }
}
function getMenu(
  tree: any,
  user: UserProps | undefined,
  category_id: string | undefined,
  group_id: string | undefined,
  tab_id: string | undefined,
): MenuProps {
  const result: MenuProps = {
    category_id: category_id,
    group_id: group_id,
    tab_id: tab_id,
    category: null,
    group: null,
    tab: null,
    category_list: null,
    group_list: null,
    tab_list: null,
    page: null,
    group_loading: false,
    tab_loading: false,
  };

  const crud: CRUDCheck = {
    crud: null,
    create: null,
    read: null,
    update: null,
    delete: null,
  };
  const tree_key: treeKey = { category: "", group: "", tab: "" };
  let auth: Record<string, AuthCRUD> | undefined;

  result.category = tree;

  setLink(result.category);
  checkCRUD(result.category, crud, user);
  result.category_list = Object.values(tree);
  if (result.category_id == null || result.category_id === "") {
    result.category_id = firstMenu(tree);
  }
  tree_key.category = findKey(result.category, result.category_id);
  result.group = tree[tree_key.category]?.sub;
  //Debug(result.group);

  if (result.group == null || Object.keys(result.group).length == 0) {
    //Debug("result group is null");
    result.group = null;
    result.page = result.category[tree_key.category];
  } else if ((result.group_id == null || result.group_id === "") && result.category[tree_key.category].page) {
    result.page = result.category[tree_key.category];
  }

  if (result.page == null && result.group != null) {
    if (tree[tree_key.category]?.auth) {
      auth = tree[tree_key.category].auth as Record<string, AuthCRUD>;
    }

    crudInit(tree[tree_key.category], crud);
    setLink(result.group, result.category_id);
    checkCRUD(result.group, crud, user, auth);

    result.group_list = Object.values(result.group);

    if (result.group_id == null || result.group_id === "") {
      result.group_id = firstMenu(result.group);
    }
    tree_key.group = findKey(result.group, result.group_id);
    result.tab = result.group[tree_key.group]?.sub;
    if (result.tab == null || Object.keys(result.tab).length == 0) {
      //Debug("result tab is null - " + tree_key.group + "," + result.group_id);
      result.tab = null;
      result.page = result.group[tree_key.group];
    } else if ((result.tab_id == null || result.tab_id === "") && result.group[tree_key.group].page) {
      result.page = result.group[tree_key.group];
    }
  }

  if (result.page == null && result.tab != null) {
    if (result.group[tree_key.group].auth) {
      auth = result.group[tree_key.group].auth as Record<string, AuthCRUD>;
    }

    crudInit(result.group[tree_key.group], crud);
    setLink(result.tab, result.category_id, result.group_id);
    checkCRUD(result.tab, crud, user, auth);

    result.tab_list = Object.values(result.tab);

    if (result.tab_id == null || result.tab_id === "") {
      result.tab_id = firstMenu(result.tab);
    }
    tree_key.tab = findKey(result.tab, result.tab_id);
    result.page = result.tab[tree_key.tab];
  }

  if (result.page != null) {
    crudInit(result.page, crud);
    checkCRUDObj(result.page, crud, user);
    checkAuth(result.page, user);
  }

  if (result.group == null) {
    const notFoundCategory = findKey(result.category, firstMenu(tree));
    result.group = tree[notFoundCategory]?.sub;
    if (result.group != null) {
      result.group_list = Object.values(result.group);
    }
  }

  return result;
}

const removeSub = (arr: any[] | null) => {
  if (arr != null) {
    const temp: any[] = JSON.parse(JSON.stringify(arr));

    temp.forEach((item) => {
      if (item.sub != null) {
        item.sub = null;
      }
    });
    return temp;
  } else {
    return null;
  }
};

export function getMenuProps(url: string, user: UserProps | undefined): MenuProps {
  let hostname = "://";
  let url_string = url;
  let locale: string | undefined = undefined;
  if (url.indexOf(hostname) >= 0) {
    url_string = url_string.substring(url_string.indexOf(hostname) + hostname.length);
    // Debug("getMenuProps1", url_string);
  }
  url_string = url_string.substring(url_string.indexOf("/"));
  // Debug("getMenuProps2", url_string);
  const prelength = url_string.search(/\?|\#/);
  if (prelength > -1) {
    url_string = url_string.substring(0, prelength);
  }
  const pre_arr = url_string.split("/");
  if (pre_arr.length >= 2) {
    if (locales.includes(pre_arr[1])) {
      locale = pre_arr[1];
      pre_arr.splice(1, 1);
    }
  }
  const result = getMenu(tree, user, pre_arr[1] ?? "", pre_arr[2] ?? "", pre_arr[3] ?? "");
  if (locale) {
    result.locale = locale;
  }
  return result;
}

export default function Menu(refererurl: string, params?: LayoutProps): MenuProps {
  let hostname = "://";
  let prelink = refererurl;

  if (prelink.indexOf(hostname) >= 0) {
    prelink = prelink.substring(prelink.indexOf(hostname) + hostname.length);
    // Debug("prelink", prelink);
  }
  prelink = prelink.substring(prelink.indexOf("/"));
  // Debug("prelink", prelink);
  const prelength = prelink.search(/\?|\#/);
  if (prelength > -1) {
    prelink = prelink.substring(0, prelength);
  }
  const pre_arr = prelink.split("/");
  // Debug("pre_arr", pre_arr);
  if (pre_arr.length >= 2) {
    if (locales.includes(pre_arr[1])) {
      pre_arr.splice(1, 1);
    }
  }
  // Debug("params", params?.category_id, params?.group_id, params?.tab_id);
  const preResult = getMenu(tree, params?.user, pre_arr[1] ?? "", pre_arr[2] ?? "", pre_arr[3] ?? "");
  const result = getMenu(tree, params?.user, params?.category_id, params?.group_id, params?.tab_id);

  if (preResult.category_id != result.category_id) {
    result.group_loading = true;
    result.tab_loading = true;
  } else {
    result.group_loading = false;
    if (preResult.group_id != result.group_id) {
      result.tab_loading = true;
    } else {
      result.tab_loading = false;
    }
  }
  result.category = null;
  result.group = null;
  result.tab = null;

  result.category_list = removeSub(result.category_list);
  result.group_list = removeSub(result.group_list);
  result.tab_list = removeSub(result.tab_list);
  const locale = params?.locale ?? defaultLocale;
  result.pathname =
    (locale === defaultLocale ? "" : "/" + locale) +
    (result.category_id != null && result.category_id !== "" ? "/" + result.category_id : "") +
    (result.group_id && result.group_id !== "" ? "/" + result.group_id : "") +
    (result.tab_id && result.tab_id !== "" ? "/" + result.tab_id : "");
  // Debug(result);
  return result;
}
